'use client';

import {useEffect} from 'react';

import {initializeDatadog} from '@/lib/initializeDatadog';

export default function DatadogInitializer() {
  useEffect(() => {
    initializeDatadog();
  }, []);

  return null;
}
